import { CircleSize, IconSize } from "./LayoutProvider";

import { AHTeamIcon, AHTeamIconRelay } from "./AHTeamIcon";
import { Circle } from "./AHTheme/Circle";
import React from "react";
import { TeamIcon } from "../globalTypes";
import { graphql, useFragment } from "react-relay";
import { AHTeamIconCircle$key } from "./__generated__/AHTeamIconCircle.graphql";

export type AHTeamIconCircleSize = "small" | "smallMedium" | "medium" | "large";
export type AHTeamIconType = TeamIcon | null | keyof typeof TeamIcon;
type Props = {
  color: string | null;
  type: AHTeamIconType;
  size?: AHTeamIconCircleSize;
};

const sizeMapping: Record<
  AHTeamIconCircleSize,
  { icon: IconSize; circle: CircleSize }
> = {
  large: {
    icon: "medium",
    circle: "xlarge",
  },
  medium: {
    icon: "small",
    circle: "medium",
  },
  smallMedium: {
    circle: "smallMedium",
    icon: "listItem",
  },
  small: {
    icon: "body",
    circle: "small",
  },
};

export function AHTeamIconCircle(props: Props) {
  return (
    <Circle
      size={sizeMapping[props.size ?? "medium"].circle}
      color="primary"
      style={props.color ? { backgroundColor: props.color } : undefined}
    >
      <AHTeamIcon
        size={sizeMapping[props.size ?? "medium"].icon}
        color="lightText"
        type={props.type ?? TeamIcon.default}
      />
    </Circle>
  );
}

export function AHTeamIconCircleRelay(props: {
  size?: AHTeamIconCircleSize;
  team: AHTeamIconCircle$key;
}) {
  const team = useFragment(
    graphql`
      fragment AHTeamIconCircle on Team {
        color
        ...AHTeamIcon
      }
    `,
    props.team
  );

  return (
    <Circle
      size={sizeMapping[props.size ?? "medium"].circle}
      color="primary"
      style={team.color ? { backgroundColor: team.color } : undefined}
    >
      <AHTeamIconRelay
        size={sizeMapping[props.size ?? "medium"].icon}
        color="lightText"
        team={team}
      />
    </Circle>
  );
}
